import {
  EMemberCenterErrorCode,
  RESEND_VERIFICATION_CODE_COOLDOWN_MS,
} from 'constants/memberCenter';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/routeConfig';
import { t } from 'utils/i18n';
import { Dialog } from 'components/Dialog';
import axios from 'plugins/api/axios';
import { useLoadingService } from 'services/LoadingService';

const { memberCenter } = axios;

export interface IUnverifiedAccountProps {
  account: string;
  email: string;
  onClear: () => void;
}

const UnverifiedAccount = ({
  account,
  email,
  onClear,
}: IUnverifiedAccountProps) => {
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoadingService();

  const handleGoToVerify = async () => {
    onClear();
    showLoading();
    const response = await memberCenter.resendVerifyDevice({
      account,
      project: 'OneTeacher',
    });
    hideLoading();

    const resendAvailableAt =
      response.err === EMemberCenterErrorCode.SUCCESS
        ? Date.now() + RESEND_VERIFICATION_CODE_COOLDOWN_MS
        : 0;

    const params = new URLSearchParams({
      account,
      email,
      resendAvailableAt: String(resendAvailableAt),
      source: 'login',
    });
    navigate(`${PATH.VERIFY_EMAIL}?${params.toString()}`);
  };

  return (
    <Dialog
      open
      title={t('login.unverifiedAccount.title', '帳號尚未完成驗證')}
      close={{ show: false, action: () => {} }}
      disConfirm={{
        text: t('login.unverifiedAccount.backToLogin', '回登入表單'),
        show: true,
        action: onClear,
      }}
      confirm={{
        text: t('login.unverifiedAccount.goToVerify', '前往驗證'),
        show: true,
        action: handleGoToVerify,
      }}
    >
      {t('login.unverifiedAccount.hint', '請完成信箱驗證才能登入使用')}
    </Dialog>
  );
};

export default UnverifiedAccount;
